"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyClosedNotification = void 0;
const adaptivecards_1 = require("adaptivecards");
const commands_1 = require("../../_shared/commands");
const AppealTitle_1 = require("../../_shared/components/AppealTitle");
const DetailsBar_1 = require("../../_shared/components/DetailsBar");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
const commands_2 = require("../commands");
function SurveyClosedNotification(survey, reasonForClosure, appealConversationId, appealMessageId, parentMessageId, notificationMessageId) {
    const surveyTypeDisplay = (0, CardHelper_1.getSurveyTypeDisplay)(survey.type);
    const card = CardHelper_1.CardHelper.newCard();
    const surveyClosureReasonText = reasonForClosure ? `early since ${reasonForClosure}, ` : "";
    const surveyClosureText = `Your ${surveyTypeDisplay} has closed ${surveyClosureReasonText || "and the results are in"}.`;
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: surveyClosureText,
        size: adaptivecards_1.TextSize.Large,
        weight: adaptivecards_1.TextWeight.Bolder,
        color: adaptivecards_1.TextColor.Accent,
        wrap: true,
    }));
    card.addItem((0, AppealTitle_1.AppealTitle)(survey));
    if (survey.description) {
        card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
            text: survey.description,
            spacing: adaptivecards_1.Spacing.Medium,
            wrap: true,
        }));
    }
    card.addItem((0, DetailsBar_1.detailsBar)(survey));
    card.addAction(CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
        // NOTE: if this text is changed, make sure to change the text in Polly preview as well.
        title: "View all results",
        data: (0, commands_2.SurveyResultsViewCommand)(survey.id).toTaskFetchCommand(),
    }));
    if (appealConversationId) {
        card.addAction((0, commands_1.SurveyDeepLinkAction)(survey.tenantId, survey.type, null, appealConversationId, appealMessageId, parentMessageId));
    }
    card.addAction((0, commands_1.DeleteCardAction)(notificationMessageId));
    return card;
}
exports.SurveyClosedNotification = SurveyClosedNotification;
//# sourceMappingURL=SurveyClosedNotification.js.map